/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * UserDefinedPromocode Input Action
 */
export class UserDefinedPromocodeInput implements Msdyn365.IActionInput {

    //   Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `userDefinedPromoCodes`;
    public getCacheObjectType = () => 'userDefinedPromoCodes';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

//   Create a data model here or import one to capture the response of the action
export interface IUserDefinedPromocodeData {
    userDefinedPromos: string[];
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new UserDefinedPromocodeInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: UserDefinedPromocodeInput, ctx: Msdyn365.IActionContext): Promise<IUserDefinedPromocodeData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    //   Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IUserDefinedPromocodeData[]>('/get/example/id/1', 'get');
    return { userDefinedPromos: [] };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IUserDefinedPromocodeData>>action,
    //   Give your data action a unique id
    id: 'UserDefinedPromocode',
    input: createInput
    //   Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
